export default __webpack_public_path__ + "static/logoMobile-9c343518ef6540a0cf7eb1f3b93e7061.svg";